import React, {useEffect, useState} from "react";
import TextInput from "../../../components/common/input-field/TextInput";
import {Controller, useForm} from "react-hook-form";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {checkEmptySpaces, maxLength, Required,} from "../../../utils/patterns";
import DescriptionInput from "../../../components/common/description-field/DescriptionField";
import {Form} from "react-bootstrap";
import {notification} from "antd";
import {RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {CreateForumService} from "../../../services/forum.service";
import {UserAuthService} from "../../../services/user-auth-api.service";
import ThemeDatePicker from "../../../components/common/date-picker/ThemeDatePicker";
import dayjs from "dayjs";
import {formateDate} from "../../../utils/constant";

const CreateForum = ({
  setModalIsOpen,
  isEdit,
  setRenderContent,
  renderContent,
  selectedForum,
}) => {
  const [authUser, setAuthUser] = useState('')

  async function GetProfileData() {
    // setLoading(true)
    const response = await UserAuthService.getProfileData();
    if (response?.data?.data?.status) {
      // setLoading(false)
      setAuthUser(response.data?.data?.data?.user)
      if (!response.data?.data?.data?.user?.forumId){
        // navigate('/')
      }
    }
  }


  useEffect(() => {
    GetProfileData();
  }, []);

  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
    clearErrors,
    watch,
  } = useForm({
    mode: "onChange",
  });

  const [loader, setLoader] = useState(false);

  useEffect(() => {

    if (isEdit && selectedForum !== null) {
      setValue("headline", selectedForum?.progressUpdate?.personal?.headline);
      setValue("emotions", selectedForum?.progressUpdate?.personal?.emotion);
      setValue('date', dayjs(formateDate(selectedForum.date), "MM/DD/YYYY"));
      setValue(
        "significant_emotions",
        selectedForum?.progressUpdate?.personal?.impact
      );
      setValue(
        "headline_Family",
        selectedForum?.progressUpdate?.family?.headline
      );
      setValue(
        "emotions_Family",
        selectedForum?.progressUpdate?.family?.emotion
      );
      setValue(
        "significant_emotions_Family",
        selectedForum?.progressUpdate?.family?.impact
      );
      setValue(
        "headline_Professional",
        selectedForum?.progressUpdate?.professional?.headline
      );
      setValue(
        "emotions_Professional",
        selectedForum?.progressUpdate?.professional?.emotion
      );
      setValue(
        "significant_emotions_Professional",
        selectedForum?.progressUpdate?.professional?.impact
      );
    }
  }, [isEdit, selectedForum]);

  const onSubmit = async (data) => {
    if (data) {
      let personalObj = {
        headline: data?.headline,
        emotion: data?.emotions,
        impact: data?.significant_emotions,
      };
      let familyObj = {
        headline: data?.headline_Family,
        emotion: data?.emotions_Family,
        impact: data?.significant_emotions_Family,
      };
      let professionalObj = {
        headline: data?.headline_Professional,
        emotion: data?.emotions_Professional,
        impact: data?.significant_emotions_Professional,
      };

      let payload = {
        forumId: authUser?.forumId,
        personal: personalObj,
        family: familyObj,
        professional: professionalObj,
        date:dayjs(data.date).format('YYYY-MM-DD')
      };

      let formId = "";

      if (isEdit) {
        formId = selectedForum?._id;
      } else {
        formId = "";
      }

      try {
        setLoader(true)
        let res = await CreateForumService(payload, formId);
        if (res?.data?.data?.status) {
          notification.success({
            message: "Success",
            description: res?.data?.data?.message,
            placement: "topRight",
            icon: <RoundedCheck />,
            duration: 2,
          });
        }
      } catch (error) {
      } finally {
        setModalIsOpen(false);
        setLoader(false)
        setRenderContent(!renderContent);
      }
    }
  };

  return (
    <div className={"create-forum"}>
      {/*<p style={{ color: "#817A8E", fontWeight: 600 }}>*/}
      {/*  Faith - Family - Fitness - Finances*/}
      {/*</p>*/}
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <div className={"dfields"}>
            <Controller
                name="date"
                defaultValue={
                  selectedForum && isEdit && selectedForum.date
                      ? dayjs(formateDate(selectedForum.date), "MM/DD/YYYY")
                      : null // Keeps the date picker empty
                }
                control={control}
                rules={{
                  required: Required,
                }}
                render={({ field: { name, ...field } }) => (
                    <ThemeDatePicker
                        label={"Date"}
                        className={'required'}
                        field={field}
                        fieldName={name}
                        errors={errors.date}
                        // defaultValue={dayjs(formateDate(selectedForum?.date), "DD/MM/YYYY")}
                        defaultValue={
                          selectedForum && isEdit && selectedForum.date
                              ? dayjs(formateDate(selectedForum.date), "MM/DD/YYYY")
                              : null // Keeps the date picker empty
                        }
                        setValue={setValue}
                    />
                )}
            />
          </div>
          <h4 style={{ color: "white" }}>Personal</h4>
          <div className={"dfields"}>
            <Controller
              name="headline"
              //   defaultValue={"Evan"}
              control={control}
              rules={{
                required: Required,
                maxLength: maxLength(150),
                validate: checkEmptySpaces,
              }}
              render={({ field: { name, ...field } }) => (
                <TextInput
                  placeholder={"Write here..."}
                  label={"Headline"}
                  type={"text"}
                  field={field}
                  errors={errors.headline}
                  className={"required"}
                />
              )}
            />
          </div>
          <div className={"dfields"}>
            <Controller
              name="emotions"
              // defaultValue={"Evan"}
              control={control}
              rules={{
                required: Required,
                maxLength: maxLength(2000),
                validate: checkEmptySpaces,
              }}
              render={({ field: { name, ...field } }) => (
                <DescriptionInput
                  rows={3}
                  autoSize={{ minRows: 3, maxRows: 9 }}
                  placeholder={"Write here..."}
                  label={"Emotion: What emotions am i feeling?"}
                  type={"text"}
                  field={field}
                  errors={errors.emotions}
                  className={"required"}
                />
              )}
            />
          </div>
          <div className={"dfields"}>
            <Controller
              name="significant_emotions"
              // defaultValue={"Evan"}
              control={control}
              rules={{
                required: Required,
                maxLength: maxLength(2000),
                validate: checkEmptySpaces,
              }}
              render={({ field: { name, ...field } }) => (
                <DescriptionInput
                  rows={3}
                  autoSize={{ minRows: 3, maxRows: 9 }}
                  placeholder={"Write here..."}
                  label={"Impact: Why this is significant for me?"}
                  type={"text"}
                  field={field}
                  errors={errors.significant_emotions}
                  className={"required"}
                />
              )}
            />
          </div>
        </div>
        <div>
          <h4 style={{ color: "white" }} className={'mt-4'}>Family</h4>
          <div className={"dfields"}>
            <Controller
              name="headline_Family"
              //   defaultValue={"Evan"}
              control={control}
              rules={{
                required: Required,
                maxLength: maxLength(150),
                validate: checkEmptySpaces,
              }}
              render={({ field: { name, ...field } }) => (
                <TextInput
                  placeholder={"Write here..."}
                  label={"Headline"}
                  type={"text"}
                  field={field}
                  errors={errors.headline_Family}
                  className={"required"}
                />
              )}
            />
          </div>
          <div className={"dfields"}>
            <Controller
              name="emotions_Family"
              // defaultValue={"Evan"}
              control={control}
              rules={{
                required: Required,
                maxLength: maxLength(2000),
                validate: checkEmptySpaces,
              }}
              render={({ field: { name, ...field } }) => (
                <DescriptionInput
                  rows={3}
                  autoSize={{ minRows: 3, maxRows: 9 }}
                  placeholder={"Write here..."}
                  label={"Emotion: What emotions am i feeling?"}
                  type={"text"}
                  field={field}
                  errors={errors.emotions_Family}
                  className={"required"}
                />
              )}
            />
          </div>
          <div className={"dfields"}>
            <Controller
              name="significant_emotions_Family"
              // defaultValue={"Evan"}
              control={control}
              rules={{
                required: Required,
                maxLength: maxLength(2000),
                validate: checkEmptySpaces,
              }}
              render={({ field: { name, ...field } }) => (
                <DescriptionInput
                  rows={3}
                  autoSize={{ minRows: 3, maxRows: 9 }}
                  placeholder={"Write here..."}
                  label={"Impact: Why this is significant for me?"}
                  type={"text"}
                  field={field}
                  errors={errors.significant_emotions_Family}
                  className={"required"}
                />
              )}
            />
          </div>
        </div>
        <div>
          <h4 style={{ color: "white" }} className={'mt-4'}>Professional</h4>
          <div className={"dfields"}>
            <Controller
              name="headline_Professional"
              //   defaultValue={"Evan"}
              control={control}
              rules={{
                required: Required,
                maxLength: maxLength(150),
                validate: checkEmptySpaces,
              }}
              render={({ field: { name, ...field } }) => (
                <TextInput
                  placeholder={"Write here..."}
                  label={"Headline"}
                  type={"text"}
                  field={field}
                  errors={errors.headline_Professional}
                  className={"required"}
                />
              )}
            />
          </div>
          <div className={"dfields"}>
            <Controller
              name="emotions_Professional"
              // defaultValue={"Evan"}
              control={control}
              rules={{
                required: Required,
                maxLength: maxLength(2000),
                validate: checkEmptySpaces,
              }}
              render={({ field: { name, ...field } }) => (
                <DescriptionInput
                  rows={3}
                  autoSize={{ minRows: 3, maxRows: 9 }}
                  placeholder={"Write here..."}
                  label={"Emotion: What emotions am i feeling?"}
                  type={"text"}
                  field={field}
                  errors={errors.emotions_Professional}
                  className={"required"}
                />
              )}
            />
          </div>
          <div className={"dfields"}>
            <Controller
              name="significant_emotions_Professional"
              // defaultValue={"Evan"}
              control={control}
              rules={{
                required: Required,
                maxLength: maxLength(2000),
                validate: checkEmptySpaces,
              }}
              render={({ field: { name, ...field } }) => (
                <DescriptionInput
                  rows={3}
                  autoSize={{ minRows: 3, maxRows: 9 }}
                  placeholder={"Write here..."}
                  label={"Impact: Why this is significant for me?"}
                  type={"text"}
                  field={field}
                  errors={errors.significant_emotions_Professional}
                  className={"required"}
                />
              )}
            />
          </div>
        </div>

        <div className={"dfields"} style={{ marginTop: 38 }}>
          <ThemeButton
            text={isEdit ? "Update" : "Submit"}
            className={"btn-light-lg"}
            type={"submit"}
            loader={loader}
          />
        </div>
      </Form>
    </div>
  );
};

export default CreateForum;
